import { render, staticRenderFns } from "./Limits.vue?vue&type=template&id=9be4bfba&"
import script from "./Limits.vue?vue&type=script&lang=ts&"
export * from "./Limits.vue?vue&type=script&lang=ts&"
import style0 from "./Limits.vue?vue&type=style&index=0&id=9be4bfba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports